module.exports = __webpack_public_path__ + "static/media/photo190.9aadc9bc.jpg";